import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowDownRight"><Path fillRule="evenodd" clipRule="evenodd" d="M6.25019 4.48224L16.5002 14.7322V8.00001H19.0002V19H8.00019V16.5H14.7324L4.48242 6.25001L6.25019 4.48224Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownRight;
